// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledContentBlock, StyledPageWrapper } from '../Styled';
import { ProductsFiltersContainer } from '../../containers';
import { useGetProductsTableColumns } from './columns';
import { Table } from '@/ui';
import { Pagination } from '@/components';

// Models
import { IProduct } from '@/models/products.model';

type TProductsList = {
  productsList: IProduct[];
  isLoading: boolean;
  setProductForDelete: (product: IProduct) => void;
  handleToggleActive: (product: IProduct) => void;
  currentPage: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  canManageProduct: boolean;
};

const ProductsList = ({
  productsList,
  isLoading,
  setProductForDelete,
  currentPage,
  total,
  pageSize,
  onPageChange,
  handleToggleActive,
  canManageProduct,
}: TProductsList) => {
  const { t } = useTranslation(['products']);
  const columns = useGetProductsTableColumns({
    t,
    handleToggleActive,
    setProductForDelete,
    canManageProduct,
  });

  return (
    <StyledPageWrapper>
      <StyledContentBlock>
        <Table
          columns={columns}
          dataSource={productsList || []}
          rowKey="id"
          loading={isLoading}
          components={{
            header: {
              wrapper: ProductsFiltersContainer,
            },
          }}
        />
        <Pagination current={currentPage} total={total} pageSize={pageSize} onChange={onPageChange} />
      </StyledContentBlock>
    </StyledPageWrapper>
  );
};

export default ProductsList;
